export const BILLING_STATUSES = [
  {
    label: 'SUBMITTED',
    value: 'SUBMITTED',
  },
  {
    label: 'NEEDS APPROVAL',
    value: 'NEED_APPROVE',
  },
  {
    label: 'APPROVED',
    value: 'APPROVED',
  },
];

export const INBOUND_BLAME = [
  { value: 'Client', label: 'Client' },
  { value: 'AxleHire', label: 'Jitsu' },
  { value: 'Unknown', label: 'Unknown' },
];

export const DEFAULT_BLAME_FILTER = 'Client';

export const DISPOSITION_STATUS_APPROVE = 'Approve';
export const DISPOSITION_STATUS_REJECT = 'Reject';
export const DISPOSITION_STATUS_CHANGE = 'Change';
export const DISPOSITION_DATE_FORMAT = 'MM/DD/YYYY';
export const DISPOSITION_DATETIME_FORMAT = 'MM/DD/YYYY HH:mm';
export const DISPOSITION_REASON_NO_CHANGE = 'No Change';

export const getStatusColor = (status) => {
  switch (status) {
    case 'APPROVED':
    case 'DONE':
      return '#1f8600';
    case 'NEED_APPROVE':
    case 'PENDING':
      return '#fa6624';
    case 'REJECTED':
    case 'ERROR':
    case 'DUPLICATED':
      return '#d0021b';
    case 'SUBMITTED':
      return '#737273';
    default:
      return 'inherit';
  }
};

export const getStatusLabel = (text) => BILLING_STATUSES.find((status) => status.value === text)?.label || text;

export const FEATURE_CATEGORY = [
  { label: 'Client Service', uri: 'client-services', enable: true },
  {
    label: 'Warehouse',
    uri: 'warehouses',
    enable: true,
    redirectUri: '/warehouses',
  },
  {
    label: 'Booking',
    uri: 'bookings',
    enable: true,
    items: [
      {
        label: 'Forecast',
        uri: 'forecast',
        enable: true,
        redirectUri: '/forecast',
      },
      { label: 'Direct Booking', uri: 'direct-booking', enable: true },
      { label: 'Driver Match', uri: 'driver-match', enable: true },
      { label: 'Advance Booking', uri: 'advance-booking', enable: true },
    ],
  },
  { label: 'Driver', uri: 'drivers' },
  { label: 'DSP', uri: 'dsp' },
  { label: 'Routing', uri: 'routing' },
  { label: 'Outbound', uri: 'outbound' },
  { label: 'Delivery', uri: 'deliveries' },
  {
    label: 'Payment',
    uri: 'payments',
    enable: true,
    scopes: ['finance-admin', 'finance-manager', 'super-admin'],
    items: [
      {
        label: 'Pay Rate',
        uri: 'payment-formulas',
        enable: true,
        redirectUri: `${process.env.REACT_APP_PAYMENT_URL}/ic-payment/pay-rate`,
      },
      { label: 'Configurations', uri: 'configs', enable: true },
    ],
  },
];

// Environment constants
export const ENV = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
  TEST: 'test',
};
